<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="$t('support.text0')"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_public/support/info_banner01.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<!--位置块-->
				<div v-if="infoData" class="location_box location_box2"
					data-aos="fade-left"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="location_main">
						<van-icon name="wap-home-o" size="20px" color="#000000" style="position: relative;top: 4px;" />&nbsp;
						<span style="cursor: pointer;" @click="goHome">{{ $t('support.text3') }}</span>&ensp;
						<van-icon name="arrow" size="20px" color="#000000" style="position: relative;top: 4px;" />&ensp;
						<span style="cursor: pointer;" @click="goSupport">Technical Support</span>&ensp;
						<van-icon name="arrow" size="20px" color="#000000" style="position: relative;top: 4px;" />&ensp;
						<span style="cursor: pointer;" @click="goSupport(infoData.leixing)">{{ infoData.leixing == 1 ? 'Product Knowledge' : ' ' }}</span>&ensp;
						<van-icon name="arrow" size="20px" color="#000000" style="position: relative;top: 4px;" />&ensp;
						<span class="actived">{{ infoData.title }}</span>
					</div>
				</div>
				<!--位置块-->
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div v-if="infoData" class="block_1_main">
					<div class="left">
						<div class="tit_box"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="tit">{{ infoData.title }}</div>
							<div class="time">{{ infoData.fabu_time }}</div>
						</div>
						<div class="content_box" v-html="infoData.content"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						></div>
					</div>
					<div v-if="tipsList.length > 0" class="right"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">
							<van-icon name="hot-o" size="22px" color="#A20073" style="top: 4px;" />&nbsp;{{ $t('support.text4') }}
						</div>
						<div class="list_box">
							<div
								v-for="(value, index) in tipsList"
								:key="index"
								class="list_el"
								@click="goInfo(value)"
							>
								<!-- <img v-if="index == 0" :src="webUrl + value.image" /> -->
								<div class="title">{{ value.title }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block_1_main2"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div v-if="prevList" class="block_1_main2_el" style="margin-right: 20px;">
						<div class="tit">{{ $t('support.text5') }}&nbsp;</div>
						<div class="txt" @click="goInfo(prevList)">{{ prevList.title }}</div>
					</div>
					<div v-if="nextList" class="block_1_main2_el" style="margin-left: 20px;">
						<div class="tit">{{ $t('support.text6') }}&nbsp;</div>
						<div class="txt" @click="goInfo(nextList)">{{ nextList.title }}</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { supportInfo } from '@/api/public';  //技术支持详情
import { UPURL } from '@/util/util';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			tipsList: [],
			nextList: null,
			prevList: null,
			webUrl: UPURL,
		}
	},
	watch: {
		//
	},
	created(){
		let that = this;
		//请求详情接口
		if(that.$route.params.supportInfoId) {
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			supportInfo({ id: that.$route.params.supportInfoId.split('.')[0] }).then(res => {
				that.infoData = res.data.info;
				that.tipsList = res.data.list;
				that.nextList = res.data.nextinfo;
				that.prevList = res.data.preinfo;
				document.title = that.infoData.title;
				that.$toast.clear();
			});
		}else {
			that.$toast(that.$t('support.text7'));
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击首页
		goHome() {
			this.$router.push({ path: '/' });
		},
		//点击技术支持列表
		goSupport(value) {
			if(value == 1) {
				this.$router.push({ path: '/support/support.html' });
			}else {
				this.$router.push({ path: '/support/support.html' });
			}
		},
		//进入详情
		goInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "SupportInfo", params: { supportInfoId: value.id + '.html' } });
			that.$router.replace({ path: routeData.href });
			window.location.reload();
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		background: url(../../assets/img_public/news/news_bg_pc.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_1_main2{
			display: flex;
			width: 1264px;
			margin: 0 auto;
			padding-bottom: 80px;
			.block_1_main2_el{
				flex: 1;
				display: flex;
				padding: 24px 40px;
				background-color: #FFFFFF;
				border-radius: 8px;
				cursor: pointer;
				.txt{
					flex: 1;
					font-size: 16px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}
				.tit{
					width: auto;
					font-size: 16px;
					color: #A20073;
				}
			}
		}
		.block_1_main{
			display: flex;
			align-items: flex-start;
			width: 1264px;
			margin: 0 auto;
			padding: 100px 0;
			.left{
				flex: 1;
				padding-right: 50px;
				.content_box{
					padding-top: 50px;
					word-break: break-all;
				}
				.tit_box{
					padding-bottom: 40px;
					border-bottom: 1px solid #999999;
					text-align: center;
					.time{
						padding-top: 20px;
						color: #999999;
						font-size: 20px;
					}
					.tit{
						font-size: 42px;
						font-weight: bold;
					}
				}
			}
			.right{
				width: 290px;
				padding: 30px 24px 18px 24px;
				background: #FFFFFF;
				box-shadow: 0px 0px 20px 1px rgba(0,0,0,0.05);
				border-radius: 8px 8px 8px 8px;
				.list_box{
					.list_el{
						padding: 12px 0;
						border-top: 1px solid #ECE7E8;
						cursor: pointer;
						.title{
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						img{
							width: 100%;
							margin-bottom: 12px;
						}
					}
				}
				.tit{
					padding-bottom: 10px;
					font-size: 20px;
					font-weight: bold;
				}
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.location_box2{
			width: 100%;
			position: absolute;
			bottom: 0;
			border-top: 1px solid #ffffff;
		}
		img{
			width: 100%;
			min-width: 1264px;
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .content_box img{
	max-width: 100%;
	height: auto;
}
</style>